import { Instagram, Linkedin, ArrowUpRight } from "lucide-react";
import { BRAND, waLink, CTA } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative overflow-hidden bg-[#0a0a0a] pt-24"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="relative overflow-hidden rounded-3xl border border-yellow-400/20 bg-gradient-to-br from-[#141414] to-[#0a0a0a] px-6 py-16 text-center sm:px-16 sm:py-24">
          <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-yellow-400/15 blur-[120px]" />
          <p className="font-mono-accent mb-6 text-xs uppercase tracking-[0.3em] text-yellow-400">
            / Let's talk growth
          </p>
          <h2 className="mx-auto max-w-4xl font-display text-5xl uppercase leading-[0.9] text-white sm:text-8xl">
            {CTA.heading}
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base text-neutral-400">
            {CTA.subtext}
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-book-button"
            className="group mt-10 inline-flex items-center gap-3 rounded-full bg-yellow-400 px-8 py-4 text-base font-semibold text-black transition-[transform,box-shadow] duration-300 hover:scale-[1.03] hover:shadow-[0_0_45px_rgba(250,204,21,0.55)]"
          >
            {CTA.button}
            <span className="grid h-7 w-7 place-items-center rounded-full bg-black text-yellow-400 transition-transform duration-300 group-hover:rotate-45">
              <ArrowUpRight size={16} />
            </span>
          </a>
        </Reveal>
      </div>

      <div className="mx-auto mt-20 max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col items-center justify-between gap-8 border-t border-white/10 py-10 sm:flex-row">
          <img src={BRAND.logo} alt="Growth Therapy" className="h-16 w-auto sm:h-20" />

          <div className="flex items-center gap-3">
            <a
              href={BRAND.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="group inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2.5 text-sm text-neutral-300 transition-colors hover:border-yellow-400 hover:text-yellow-400"
            >
              <Instagram size={16} />
              Instagram
            </a>

            <a
              href={BRAND.linkedin}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-linkedin"
              className="group inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2.5 text-sm text-neutral-300 transition-colors hover:border-yellow-400 hover:text-yellow-400"
            >
              <Linkedin size={16} />
              LinkedIn
            </a>
          </div>

          <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-neutral-500">
            © {new Date().getFullYear()} Growth Therapy
          </p>
        </div>
      </div>

      <div className="pointer-events-none select-none overflow-hidden">
        <p className="font-display -mb-4 text-center text-[22vw] uppercase leading-none text-white/[0.03]">
          Growth
        </p>
      </div>
    </footer>
  );
};
